<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0 mt-4"
      >
        <div class="finanical-report-messages">
          <h1 class="section_header">Productivity</h1>
          <!-- <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>
                Is your sales per employee efficiency measure above or below the
                US industry and market average? Sales per Employee levels are
                compared to your firm levels if you input both sales and
                employment for those years. Average annual industry wages and
                rent per employee are displayed and benchmarked against your
                firm wage levels if they were input.
          </p>-->
          <!-- <p>How much more or less efficient is your operation relative to the competition? The Sales per Employee Index expresses your
                firm’s SPE as a percentage comparison to market and US levels where 100% reflects the same level. A zero per cent rating (+0%)
                indicates parity with the market benchmark. <br> <br>
                The Efficiency Index divides sales per employee by average annual worker salary. Non‐wage factors may also affect efficiency
                but are not represented by this index. <br> <br>
                How much more or less efficient is your operation relative to the competition? The Sales per Employee Index expresses your
                firm's SPE as a percentage comparison to market and US levels where 100% reflects the same level.
          </p>-->
          <!-- </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>-->
        </div>
        <div class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0">
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab md-label="Values" md-icon="window" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Value</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-medium-size-100 md-size-100 blue-tbl">
                              <!--<md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      ABC Plumbing Competitive Productivity
                                      Analysis
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">

                                    <p>
                                      ABC Plumbing sales per employee are
                                      $152,636, 3% above the local industry
                                      market level[, compared to a -19%
                                      differential against the national
                                      average]. At $42,535, average annual firm
                                      wages are 7.81% below the [local] industry
                                      market average[ and lower than the
                                      Plumbing, Heating, and Air-Conditioning
                                      Contractors segment nation-wide]. ABC
                                      Plumbing Rent per Employee, an
                                      expense-specific efficiency metric, is
                                      $552, while the average industry market
                                      rent per employee figure is $2,580.
                                    </p>
                                  </div>
                                </md-card-content>
                              </md-card>-->
                            </div>
                            <div class="md-layout-item md-size-100 blue-tbl">
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Sales Per Employee ($</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">
                                    Sales Per Employee ($)
                                  </h4>-->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="tableDataSalesPerEmployee"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="years[key]"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Average Annual Wage ($)</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">
                                    Average Annual Wage ($)
                                  </h4>-->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table border-0 p-0"
                                    >
                                      <md-table
                                        v-model="tableDataAverageAnnualWage"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="years[key]"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Rent Per Employee ($)</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Rent Per Employee ($)</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="tableDataRentPerEmployee"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="years[key]"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                               <md-card class="md-card-profile">
                                  <md-card-header>
                                    <h4 class="title m-0">
                                      <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                        Competitive Market Narrative
                                      </div>
                                    </h4>
                                  </md-card-header>
                                  <md-card-content>
                                    <div class="extra_space">
                                          <!-- <h4 class="Performance Scores">
                                            Competitive Market Narrative
                                          </h4> -->
                                      <p>
                                      {{cmnText.productivity.valuesTop}}
                                      </p>
                                    </div>
                                  </md-card-content>
                                </md-card>
                              <md-card class="md-card-profile ">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Values
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                        <p>
                                           {{cmnText.productivity.values}}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
                <md-tab md-label="Index/Chart" md-icon="legend_toggle" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Index/Chart</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-medium-size-100 md-size-100">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      ABC Plumbing Competitive Productivity
                                      Analysis
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                      ABC Plumbing Competitive Productivity Analysis
                                    </h4>-->
                                    <p>
                                      ABC Plumbing sales per employee are
                                      $152,636, [3% above the local industry
                                      market level, compared to] a -19%
                                      differential against the national
                                      average.​
                                    </p>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-size-100">
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Productivity Indices (Prime Plumbing)</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">
                                    Productivity Indices (Prime Plumbing)
                                  </h4>-->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                                      <md-table
                                        v-model="tableDataProductivityIndices"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                          </div>
                          <div class="md-layout px-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-content>
                                  <chart-card
                                    header-animation="false"
                                    :chart-data="colouredLineChart.data"
                                    :chart-options="colouredLineChart.options"
                                    chart-type="Line"
                                    header-icon
                                    chart-inside-content
                                    no-footer
                                    background-color="blue"
                                  >
                                    <template slot="chartInsideHeader">
                                      <h4 class="title m-0">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                        >Sales per Employee ($)</div>
                                      </h4>
                                      <!-- <h4 class="title">Sales per Employee ($)</h4> -->
                                    </template>
                                  </chart-card>
                                </md-card-content>
                              </md-card>
                            </div>
                                  <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                      Competitive Market Narrative
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <!-- <div class="md-card-header md-card-header-icon md-card-header-blue"></div>
                                  <h4 class="Performance Scores">
                                    Competitive Market Narrative
                                  </h4> -->
                                  <div class="extra_space">
                                    <p>
                                     {{cmnText.productivity.index}}
                                    </p>
                                  </div>
                                </md-card-content>
                              </md-card>
                              <md-card class="md-card-profile ">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Penetration
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                        <p>
                                         How much more or less efficient is your operation relative to the competition?
                                         The Sales per Employee Index expresses your firm’s SPE as a percentage comparison
                                         to market and US levels where 100% reflects the same level. A zero per cent rating (+0%)
                                         indicates parity with the market benchmark. <br><br>The Efficiency Index divides sales per employee
                                         by average annual worker salary. Non‐wage factors may also affect efficiency but are not represented by this index.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">

                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MRReportHeader,
  },
  computed: {
    ...mapState({
      productivityValues: (state) =>
        state.user.market_report.data.data['productivityValues'],
      productivityIndex: (state) =>
        state.user.market_report.data.data['productivityIndex'],
      years: (state) => state.user.market_report.data.years,
      cmnText: (state) =>state.user.market_report.cmnText,
    }),
  },
  props: ['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      showDialog: false,
      tableDataSalesPerEmployee: [],
      tableDataAverageAnnualWage: [],
      tableDataRentPerEmployee: [],
      tableDataProductivityIndices: [],

      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 80,
          },
          low: 0,
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: '300px',
        },
      },
    };
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'cash-flow-solvency';
    }
    this.switchView(section);
    let me = this;

    this.tableDataSalesPerEmployee = Object.entries(
      this.productivityValues.spe
    ).map(([name, data]) => ({ name, dates: data }));

    this.tableDataSalesPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    this.tableDataAverageAnnualWage = Object.entries(
      this.productivityValues.annualWage
    ).map(([name, data]) => ({ name, dates: data }));
    this.tableDataAverageAnnualWage.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    this.tableDataRentPerEmployee = Object.entries(
      this.productivityValues.rent
    ).map(([name, data]) => ({ name, dates: data }));
    this.tableDataRentPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    if (this.productivityIndex) {
      this.tableDataProductivityIndices = Object.entries(
        this.productivityIndex
      ).map(([table]) => ({ name: table }));
    } else {
      this.tableDataProductivityIndices = [];
    }
    let newTableRentPerEmployee = Object.entries(
      this.productivityValues.rent
    ).map(([name, data]) => ({ name, dates: data }));
    newTableRentPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return Number(e);
      });
      return item;
    });
    this.colouredLineChart.data = {
      labels: this.years,
      series: newTableRentPerEmployee.map((item) => ({
        name: item.name,
        data: item.dates,
      })),
    };
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'cash-flow-solvency';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }
    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
